import { z } from 'zod';
import { UnixTimestamp } from '@triedge/domain-core/types';
import { FormStatusSchema } from '../types/enums';

export const PortalFormSchema = z.object({
  id: z.string(),
  title: z.string(),
  status: FormStatusSchema,
  dueDate: UnixTimestamp.nullable().optional(),
  submittedAt: UnixTimestamp.nullable().optional(),
  completedAt: UnixTimestamp.nullable().optional(),
  required: z.boolean(),
});
export type PortalForm = z.infer<typeof PortalFormSchema>;
